// ↓ 登录页
import LogInPage from '../views/LogInPage.vue'
// ↓ 主页
const MainPage = () => import(/* webpackChunkName: 'MainPage' */ '../views/MainPage.vue');
// ↓ 选择系统页面
const SelectSystem = () => import(/* webpackChunkName: 'MainPage' */ '../content/SelectSystem.vue');
// ↓ 客户管理
const CustomerAdmin = () => import(/* webpackChunkName: 'MainPage' */ '../content/CustomerAdmin.vue');
// ↓ 数据库管理
const DataBaseAdmin = () => import(/* webpackChunkName: 'MainPage' */ '../content/DataBaseAdmin.vue');
// ↓ 收到的反馈问题管理
const FeedbackQuestionsAdmin = () => import(/* webpackChunkName: 'MainPage' */ '../content/FeedbackQuestionsAdmin.vue');

/*------------------------------- ↓ 设备管理平台 -------------------------------*/
// ↓ 设备状态
const EQPStatus = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/EQPStatus.vue');
// ↓ 素材管理
const MaterialAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/MaterialAdmin.vue');
// ↓ 节目发布管理
const ProgramReleaseAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/ProgramReleaseAdmin.vue');
// ↓ 设备管理
const EQPAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/EQPAdmin.vue');
// ↓ 坐标管理
const CoordinateAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/CoordinateAdmin.vue');
// ↓ 统计分析
const StatisticsAnalysis = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/StatisticsAnalysis.vue');
// ↓ 用户管理
const UserAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/UserAdmin.vue');
// ↓ 权限管理
const AuthAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/AuthAdmin.vue');
// // ↓ 数据库管理
// const DataBaseAdmin = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/DataBaseAdmin.vue');
// ↓ 操作日志
const OperationLog = () => import(/* webpackChunkName: 'EQPManagement' */ '../content/EQPManagement/OperationLog.vue');



/*--------------------------------- ↓ 业务问答 ---------------------------------*/
// ↓ 问答库
const BusinessQA_QABase = () => import(/* webpackChunkName: 'BusinessQA' */ '../content/BusinessQA/QABase.vue');
// ↓ 专属词库
const BusinessQA_OwnWordsBase = () => import(/* webpackChunkName: 'BusinessQA' */ '../content/BusinessQA/OwnWordsBase.vue');
// ↓ 智能学习
const BusinessQA_AIlearning = () => import(/* webpackChunkName: 'BusinessQA' */ '../content/BusinessQA/AIlearning.vue');
// ↓ 问答记录
const BusinessQA_QARecord = () => import(/* webpackChunkName: 'BusinessQA' */ '../content/BusinessQA/QARecord.vue');



/*------------------------------- ↓ 留言管理平台 -------------------------------*/
// ↓ 被留言人管理
const AIMessage_GetMsgPersonAdmin = () => import(/* webpackChunkName: 'AIMessage' */ '../content/AIMessage/GetMsgPersonAdmin.vue');
// ↓ 留言管理
const AIMessage_MessageAdmin = () => import(/* webpackChunkName: 'AIMessage' */ '../content/AIMessage/MessageAdmin.vue');
// ↓ 留言统计
const AIMessage_MessageStatistics = () => import(/* webpackChunkName: 'AIMessage' */ '../content/AIMessage/MessageStatistics.vue');



/*--------------------------------- ↓ 导航管理 ---------------------------------*/
// ↓ 项目列表 管理
const PathNav_ProjectListAdmin = () => import(/* webpackChunkName: 'PathNav' */ '../content/PathNav/ProjectListAdmin.vue');
// ↓ 文件上传 管理
const PathNav_FileUploadAdmin = () => import(/* webpackChunkName: 'PathNav' */ '../content/PathNav/FileUploadAdmin.vue');
// ↓ POI分类 管理
const PathNav_POITypeAdmin = () => import(/* webpackChunkName: 'PathNav' */ '../content/PathNav/POITypeAdmin.vue');
// ↓ APP列表 管理
const PathNav_APPListAdmin = () => import(/* webpackChunkName: 'PathNav' */ '../content/PathNav/APPListAdmin.vue');



const routes = [{
    // ↓ 登录页
    path: '/LogIn',
    name: 'LogInPage',
    component: LogInPage
  },{
    // ↓ 主页
    path: '/Main',
    name: 'MainPage',
    component: MainPage,
    redirect: '/SelectSystem',
    children: [
      {
        // ↓ 选择系统页面
        path: '/SelectSystem',
        name: 'SelectSystem',

        component: SelectSystem
      },
      {
        // ↓ 客户管理
        path: '/CustomerAdmin',
        name: 'CustomerAdmin',
        meta: { system: 'CustomerAdmin' },
        component: CustomerAdmin
      },
      {
        // ↓ 数据库管理
        path: '/DataBaseAdmin',
        name: 'DataBaseAdmin',
        meta: { system: 'CustomerAdmin' },
        component: DataBaseAdmin
      },
      {
        // ↓ 反馈问题管理
        path: '/FeedbackQuestionsAdmin',
        name: 'FeedbackQuestionsAdmin',
        meta: { system: 'CustomerAdmin' },
        component: FeedbackQuestionsAdmin
      },
      /*---------------------- ↓ 设备管理平台 ----------------------*/
      {
        // ↓ 设备状态
        path: '/EQPManagement/EQPStatus',
        name: 'EQPStatus',
        meta: { system: 'EQPManagement' },
        component: EQPStatus
      },{
        // ↓ 素材管理
        path: '/EQPManagement/MaterialAdmin',
        name: 'MaterialAdmin',
        meta: { system: 'EQPManagement' },
        component: MaterialAdmin
      },{
        // ↓ 节目发布管理
        path: '/EQPManagement/ProgramReleaseAdmin',
        name: 'ProgramReleaseAdmin',
        meta: { system: 'EQPManagement' },
        component: ProgramReleaseAdmin
      },{
        // ↓ 设备管理
        path: '/EQPManagement/EQPAdmin',
        name: 'EQPAdmin',
        meta: { system: 'EQPManagement' },
        component: EQPAdmin
      },{
        // ↓ 坐标管理
        path: '/EQPManagement/CoordinateAdmin',
        name: 'CoordinateAdmin',
        meta: { system: 'EQPManagement' },
        component: CoordinateAdmin
      },{
        // ↓ 统计分析
        path: '/EQPManagement/StatisticsAnalysis',
        name: 'StatisticsAnalysis',
        meta: { system: 'EQPManagement' },
        component: StatisticsAnalysis
      },{
        // ↓ 用户管理
        path: '/EQPManagement/UserAdmin',
        name: 'UserAdmin',
        meta: { system: 'EQPManagement' },
        component: UserAdmin
      },{
        // ↓ 权限管理
        path: '/EQPManagement/AuthAdmin',
        name: 'AuthAdmin',
        meta: { system: 'EQPManagement' },
        component: AuthAdmin
      },
      // {
      //   // ↓ 数据库管理
      //   path: '/EQPManagement/DataBaseAdmin',
      //   name: 'DataBaseAdmin',
      //   meta: { system: 'EQPManagement' },
      //   component: DataBaseAdmin
      // },
      {
        // ↓ 操作日志
        path: '/EQPManagement/OperationLog',
        name: 'OperationLog',
        meta: { system: 'EQPManagement' },
        component: OperationLog
      },
      /*------------------------ ↓ 业务问答 ------------------------*/
      {
        // ↓ 问答库
        path: '/BusinessQA/QABase',
        name: 'BusinessQA_QABase',
        meta: { system: 'BusinessQA' },
        component: BusinessQA_QABase
      },{
        // ↓ 专属词库
        path: '/BusinessQA/OwnWordsBase',
        name: 'BusinessQA_OwnWordsBase',
        meta: { system: 'BusinessQA' },
        component: BusinessQA_OwnWordsBase
      },{
        // ↓ 智能学习
        path: '/BusinessQA/AIlearning',
        name: 'BusinessQA_AIlearning',
        meta: { system: 'BusinessQA' },
        component: BusinessQA_AIlearning
      },{
        // ↓ 问答记录
        path: '/BusinessQA/QARecord',
        name: 'BusinessQA_QARecord',
        meta: { system: 'BusinessQA' },
        component: BusinessQA_QARecord
      },
      /*---------------------- ↓ 留言管理平台 ----------------------*/
      {
        // ↓ 被留言人管理
        path: '/AIMessage/GetMsgPersonAdmin',
        name: 'GetMsgPersonAdmin',
        meta: { system: 'AIMessage' },
        component: AIMessage_GetMsgPersonAdmin
      },{
        // ↓ 留言管理
        path: '/AIMessage/MessageAdmin',
        name: 'MessageAdmin',
        meta: { system: 'AIMessage' },
        component: AIMessage_MessageAdmin
      },{
        // ↓ 被留言人管理
        path: '/AIMessage/MessageStatistics',
        name: 'MessageStatistics',
        meta: { system: 'AIMessage' },
        component: AIMessage_MessageStatistics
			},
			/*------------------------ ↓ 导航管理 ------------------------*/
			{
				// ↓ 项目列表 管理
        path: '/PathNav/ProjectListAdmin',
        name: 'ProjectListAdmin',
        meta: { system: 'PathNav' },
        component: PathNav_ProjectListAdmin
			},{
				// ↓ 文件上传 管理
        path: '/PathNav/FileUploadAdmin',
        name: 'FileUploadAdmin',
        meta: { system: 'PathNav' },
        component: PathNav_FileUploadAdmin
			},{
				// ↓ POI分类 管理
        path: '/PathNav/POITypeAdmin',
        name: 'POITypeAdmin',
        meta: { system: 'PathNav' },
        component: PathNav_POITypeAdmin
			},{
				// ↓ APP列表 管理
        path: '/PathNav/APPListAdmin',
        name: 'APPListAdmin',
        meta: { system: 'PathNav' },
        component: PathNav_APPListAdmin
			}
    ]
  },
  {
    path: '*',
    redirect: '/Main'
  },
];

export default routes



// WEBPACK FOOTER //
// ./src/router/routesList.js